export default {
  LOG_TAG: 'WebApi:',
  ERR_API_RESP: 'Error response from API',
  ERR_API_COMM: 'Error communicating with API',
  createUrl (...args) {
    // let url = process.env.API_SRC
    let url = ''
    for (let index = 0; index < args.length; index += 1) {
      url += args[index]
      if (index < args.length - 1) {
        url += '/'
      }
    }
    return url
  },
  apiBaseHeader () {
    const object = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }
    return object
  },
  apiPost (url, payload, onResponseCb, onErrorCb) {
    const vm = this
    //
    // validate result
    const onResponse = function onResponse (response) {
      if (response && response.data) {
        onResponseCb(response)
      } else {
        onErrorCb(vm.ERR_API_RESP)
      }
    }
    const onError = function onError (error) {
      onErrorCb(error)
    }
    if (payload) {
      window.axios.post(url, payload, vm.apiBaseHeader()).then(onResponse).catch(onError)
    } else {
      window.axios.post(url, vm.apiBaseHeader()).then(onResponse).catch(onError)
    }
  }
}



// WEBPACK FOOTER //
// ./src/webapi/ApiHelper.js